var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgBlueLine = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 242,
    height: 35,
    viewBox: "0 0 242 35",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-341 32.9698H-241.225L-146.817 12.3065L-48.9307 21.142L43.6588 33L141.755 2L241 21.1319",
    stroke: "#3BC0F8",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBlueLine, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/blue-line.942db3e2.svg";
export { ForwardRef as ReactComponent };